/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Announcement_Composer_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Broadcast a message to all players…" |
*
* @param {Announcement_Composer_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const announcement_composer_placeholder = /** @type {((inputs?: Announcement_Composer_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Announcement_Composer_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diffuser un message à tous les joueurs…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Difundir un mensaje a todos los jugadores…")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Difundir uma mensagem para todos os jogadores…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trasmetti un messaggio a tutti i giocatori…")
	return /** @type {LocalizedString} */ ("Broadcast a message to all players…")
});